<div *ngIf="showGlobalSearch" class="table-search-container">

    <input type="text" pInputText placeholder="Buscar..." (input)="filter($event)" />
</div>
<p-table #dt [ngClass]="{ 'sticky-search': stickySearch, 'sticky-paginator': stickyPaginator , 'compact-paginator': compactPaginator}" paginatorStyleClass="custom-paginator" [pageLinks]="pageLinkSize" [value]="data" [dataKey]="dataKey" [lazy]="true"
    [rows]="rows" [paginator]="true" [rowsPerPageOptions]="rowsPerPageOptions" (onRowSelect)="onRowSelect($event)"
    [(selection)]="selection" (selectionChange)="onSelectionChange($event)" [globalFilterFields]="globalFilterFields"
    [sortField]="sortField" [sortOrder]="sortOrder" [first]="first" (onLazyLoad)="loadData($event)"
    [totalRecords]="totalRecords" [loading]="loading" (aceptSelection)="onAcceptSelection()" [scrollable]="true"
    >
    <ng-template pTemplate="header">
        <tr  style="font-size: 12px">
            <th *ngIf="optional" style="width: 4rem"></th>
            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
            <th style="width: 4rem"></th>
            <th *ngFor="let col of columns" [pSortableColumn]="col.orderby ? col.field : ''">
                <div class="p-column-header-content">
                    <span>{{col.header}}</span>
                    <ng-container  *ngIf="col.orderby">
                        <p-sortIcon field="{{col.field}}"></p-sortIcon>
                    </ng-container>
                    <ng-template #sortPlaceholder>
                        <span class="sort-placeholder"></span>
                    </ng-template>
                    <ng-container *ngIf="col.filter && showFilters, else placeholder">
                        <p-columnFilter *ngIf="col.field" type="text" [field]="col.field" display="menu"
                            [placeholder]="'Buscar por ' + col.header + '...'" [matchMode]="'contains'" />
                    </ng-container>
                    <ng-template #placeholder>
                        <div class="filter-placeholder"></div>
                    </ng-template>
                </div>
            </th>
            <th></th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
        <tr style="font-size: 12px">
            <button mat-icon-button *ngIf="optional" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <span class="material-symbols-outlined">more_vert</span>
            </button>
            <td><p-tableCheckbox [value]="rowData"></p-tableCheckbox></td>
            <td style="width: 4rem"></td>
            <td *ngFor="let col of columns">
                <ng-container *ngIf="col.field && rowData">
                    <ng-container *ngIf="customTemplates?.[col.field]; else default">
                        <ng-container
                            *ngTemplateOutlet="customTemplates[col.field]; context: { $implicit: getNestedValue(rowData, col.field) }">
                        </ng-container>
                    </ng-container>
                    <ng-template #default>
                        {{ getNestedValue(rowData, col.field) }}
                    </ng-template>
                </ng-container>
            </td>
            <td>

                <mat-menu #menu="matMenu">
                    <button *ngIf="itemEdit" mat-menu-item (click)="onEditItem(rowData)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                    <button *ngIf="DuplicateButton" mat-menu-item (click)="onClone(rowData)">
                        <span class="material-symbols-outlined">content_copy</span>
                        <span>Duplicar</span>
                    </button>
                    <button *ngIf="viewDetails" mat-menu-item (click)="onSeeDetails(rowData)">
                        <span class="material-symbols-outlined">list</span>
                        <span>Ver Detalle</span>
                    </button>
                    <button *ngIf="deleteButton" mat-menu-item (click)="onDeleteItems(rowData)">
                        <span class="material-symbols-outlined">delete</span>
                        <span>Eliminar</span>
                    </button>
                    <button *ngIf="retryProcess" mat-menu-item (click)="onRetry(rowData)">
                        <span class="material-symbols-outlined">Autorenew</span>
                        <span>reintentar</span>
                    </button>
                </mat-menu>
            </td>
        </tr>
    </ng-template>
    <!-- <div class="custom-paginator"> -->
        <ng-template pTemplate="paginatorleft" style="display: flex;">
            <div style="font-size: 13px; padding-left: 1rem;display: flex ;flex-direction: column;">
                <span>Total: {{ totalRecords }} registros</span>
                <span *ngIf="enableTotalSelection">Seleccionados: {{ selection.length }}</span>
            </div>
        </ng-template>
        <ng-template pTemplate="paginatorright" *ngIf="enableFooterActions">
            <div>
                <button mat-flat-button (click)="onAcceptSelection()">Aceptar</button>
                <button mat-flat-button (click)="onCancelSelection()">cancelar</button>
            </div>
        </ng-template>
    <!-- </div> -->
    <!-- <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="{{columns.length + 2}}">Cargando datos...</td>
        </tr>
    </ng-template> -->
</p-table>